var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRelogio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1869_4692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.04297V12.043L16 14.043M22 12.043C22 17.5658 17.5228 22.043 12 22.043C6.47715 22.043 2 17.5658 2 12.043C2 6.52012 6.47715 2.04297 12 2.04297C17.5228 2.04297 22 6.52012 22 12.043Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1869_4692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0429688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelogio);
export default __webpack_public_path__ + "static/media/iconRelogio.eb9431f832d85043cac64defb7d92f59.svg";
export { ForwardRef as ReactComponent };